<template>
    <div>
        <!-- Custom hint text with clickable link -->
        <div class="custom-hint-text mb-3" v-if="showHint">
            <v-icon small class="mr-1">mdi-information-outline</v-icon>
            <span>
                {{ beforeLinkText }}
                <span class="compatible-integration-link" @click="onClickShowCompatibleIntegrations"
                    style="color: #1976d2; text-decoration: underline; cursor: pointer;">
                    {{ linkText }}
                </span>
                {{ afterLinkText }}
            </span>
        </div>

        <!-- Compatible Integrations Dialog -->
        <v-dialog v-model="show_dialog" max-width="600">
            <v-card>
                <v-card-title>
                    {{ modalTitle }}
                </v-card-title>
                <v-card-text>
                    <p>{{ modalDescription }}</p>
                    <ul class="mt-3" v-if="compatible_integrations.length > 0">
                        <li v-for="integration in compatible_integrations" :key="integration.value">
                            {{ integration.text }}
                        </li>
                    </ul>
                    <p v-else class="mt-3 text--secondary">
                        {{ noIntegrationsMessage }}
                    </p>
                    <p class="mt-3 text--secondary">
                        {{ footerMessage }}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" text @click="show_dialog = false">
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'CompatibleIntegrationsHint',
    
    props: {
        // Feature identifier to check for compatibility
        featureIdentifier: {
            type: String,
            required: true
        },
        
        // Text before the clickable link
        beforeLinkText: {
            type: String,
            required: true
        },
        
        // The clickable link text
        linkText: {
            type: String,
            required: true
        },
        
        // Text after the clickable link
        afterLinkText: {
            type: String,
            required: true
        },
        
        // Modal title
        modalTitle: {
            type: String,
            required: true
        },
        
        // Modal description (first paragraph)
        modalDescription: {
            type: String,
            required: true
        },
        
        // Message when no integrations are found
        noIntegrationsMessage: {
            type: String,
            default: 'No compatible integrations are currently available to show.'
        },
        
        // Footer message in modal
        footerMessage: {
            type: String,
            default: 'More integrations will be added in the future.'
        },
        
        // Whether to show the hint (for conditional display)
        showHint: {
            type: Boolean,
            default: true
        }
    },
    
    data() {
        return {
            show_dialog: false,
            compatible_integrations: []
        }
    },
    
    mounted() {
        this.loadCompatibleIntegrations();
    },
    
    methods: {
        onClickShowCompatibleIntegrations() {
            this.show_dialog = true;
        },

        loadCompatibleIntegrations() {
            // Load compatible integrations for the specified feature
            this.$rc.getIntegrationsForFeature(
                this.featureIdentifier,
                (supporting_integrations) => {
                    // Convert the API response to the format expected by the UI
                    this.compatible_integrations = supporting_integrations.map(integration => ({
                        text: integration.text,
                        value: integration.value
                    }));
                },
                () => {
                    // Fallback to empty array if the API call fails
                    this.compatible_integrations = [];
                }
            );
        }
    }
}
</script>

<style scoped>
/* Compatible integration link styling */
.compatible-integration-link {
    color: #1976d2 !important;
    text-decoration: underline !important;
    cursor: pointer !important;
    transition: color 0.2s ease;
}

.compatible-integration-link:hover {
    color: #1565c0 !important;
}

/* Custom hint text styling to match component hints */
.custom-hint-text {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    margin-top: 4px;
    line-height: 1.4;
    display: flex;
    align-items: flex-start;
}

.custom-hint-text .v-icon {
    font-size: 14px !important;
    margin-top: 1px;
    flex-shrink: 0;
}
</style>
